


































































import { Component, Vue } from 'vue-property-decorator'
import CityIndexSearchBox from '@/components/CityIndexSearchBox/index.vue'
import Tabs from '@/components/Tabs/index.vue'
import Filtrate from '@/components/Filtrate/index.vue'
import Sort from '@/components/Sort/index.vue'
import ProductList from '@/components/ProductList/index.vue'
import { foodsThemes, foodsProducts } from '@/api/product'

@Component({
  name: 'Foods',
  components: {
    // SearchInput,
    CityIndexSearchBox,
    Tabs,
    Filtrate,
    Sort,
    ProductList
  }
})
export default class Foods extends Vue {
  private show = false

  private minPrice = ''

  private maxPrice = ''

  private page = 0

  private resultNum = 20

  private sizeAll = 0

  private sortActive = 1 // 1 推荐值 2 销量 3 发布时间 4 利润

  private sortType = 1 // 排序方式 0升序 1 降序

  // 城市
  private areaId: number | string = ''

  private keyword = '' // 搜索关键字

  private listData: any[] = []

  private labelList: any[] = []

  private loading = false

  private labelId: any[] = []

  // 清楚筛选项
  clickClear ():void {
    this.labelId = []
    this.getProductSearch()
  }

  // 获取产品主题
  getFoodsThemes (): void {
    foodsThemes({
      page: this.page,
      areaId: this.areaId
    }).then((res: any) => {
      console.log(res)
      const list = res.data.map(e => {
        return {
          id: e.themeId,
          name: e.themeName
        }
      })
      // list.unshift({
      //   id: '',
      //   name: '全部'
      // })
      this.show = true
      if (res) {
        this.labelList = [
          {
            label: '餐饮主题',
            list: list
          }
        ]
      }
    })
  }

  // 切换排序类型
  changeSort (item): void {
    this.sortType = item.sortType
    this.page = 0
    this.getProductSearch()
  }

  // 切换分页
  currentChange (item): void {
    this.page = item
    const scrollWrapper: any = this.$refs.scrollWrapper
    scrollWrapper.scrollIntoView()
    this.getProductSearch()
  }

  // 搜索事件触发
  clickSearch (item): void {
    this.keyword = item
    this.getProductSearch()
  }

  // 切换城市
  changeCity (item: number): void {
    this.areaId = item
    this.labelId = []
    this.getFoodsThemes()
    this.getProductSearch()
  }

  // 获取产品列表
  getProductSearch (): void {
    this.loading = true
    const params = {
      areaId: this.areaId,
      themeId: this.labelId as any,
      keyword: encodeURIComponent(this.keyword),
      page: this.page,
      resultNum: this.resultNum,
      sort: this.sortActive,
      sortType: this.sortType,
      treeId: ''
    }
    foodsProducts(params)
      .then(res => {
        console.log(res, 1122)
        this.loading = false
        if (res) {
          this.listData = res.results
          this.sizeAll = res.sizeAll
        }
      })
  }

  // 多选切换
  changeRadio (item) {
    console.log(item, 'checkbox')
    this.getProductSearch()
  }

  private handleChangeRadio (item) {
    this.labelId = item
    this.getProductSearch()
  }

  created () {
    this.getProductSearch()
  }

  mounted (): void {
    const { key } = this.$route.query
    if (typeof key === 'string') {
      this.keyword = key
    }
    this.getFoodsThemes()
    this.getProductSearch()
  }
}
